export default {
  GET_TRANSACTIONS: 'GET_TRANSACTIONS',
  GET_TRANSACTIONS_DONE: 'GET_TRANSACTIONS_DONE',
  TRANSACTIONS_ERROR: 'TRANSACTIONS_ERROR'
}
